import LtsLayout from 'src/onboarding/layouts/lts';

// import AnalysisLayout from './layouts/analysis/layout';
import AnalyzingAnswersPage from './pages/analyzing-answers/page';
// import AnalysisPage from './pages/analysis/page';
// import WebUpsale from './pages/webUpsale';
import WebUpsaleFirst from './pages/webUpsale/components/WebUpsaleFirst';
// import WebUpsaleSecond from './pages/webUpsale/components/WebUpsaleSecond';
import WebUpsaleThird from './pages/webUpsale/components/WebUpsaleThird';
import WebUpsaleFourth from './pages/webUpsale/components/WebUpsaleFourth';
import WebUpsaleFifth from './pages/webUpsale/components/WebUpsaleFifth';
import TermsOfUse from './pages/terms-of-use';
import PrivacyPolicy from './pages/privacy-policy';
import LegalLayout from './layouts/legal';


import NamePage from "./pages/name"

import EmailPage from "./pages/email"
import EmailAfterPaymentPage from "./pages/email-after-payment"
import LtsvPhotoExamplePage from "./pages/lts-photo-example"
import LtsResultPage from "./pages/lts-result"
import PersonalPlanPage from "./pages/personal-plan/index"
import WebUpsaleThirdNew from "./pages/web-upsale/webUpsaleThird"
import WebUpsaleFourthNew from "./pages/web-upsale/webUpsaleFourth"
import MainLayout from "./layouts/main/layout";
import TransitionLayout from "./layouts/transition";


import PersonalPlanSecond from './pages/personal-plan-2';
import EmailSecond from './pages/email-2';

import BestApp from './pages/best-app';


import Analyzing from './pages/analyzing';
import AnalyzingSecond from './pages/analyzing';
import AnalyzingThird from './pages/analyzing';
import AnalyzingFourth from './pages/analyzing';

import PersonalPlanThird from './pages/personal-plan-3';


import AnalyzingActivity from './pages/analyzing-activity';


import PersonalPlanFourth from './pages/personal-plan-4';


import PersonalPlanMetabolism from './pages/personal-plan-metabolism';
import UpsaleNutritionBundle from './pages/webUpsale/components/upsale-nutrition-bundle';

import UpsaleDynamic from './pages/upsale-dynamic';
import PersonalPlanDynamic from './pages/dynamic-personal-plan';

import FaceScanPhoto from './pages/face-scan';
import FaceScanAnimation from './pages/face-scan-animation';
import FaceScanId from './pages/face-scan-id';


//voery
import NativeLanguagePage from './pages/native-language';
import LanguageWillYouTranslatePage from './pages/language-will-you-translate';
import PaywallPage from './pages/paywall';
import TryVoeryPage from './pages/try-voery';
import VoeryCallPage from './pages/voery-call';

import ChangePaymentMethod  from './pages/change-payment-method';

export const backupFlow = [
  'native-language',
'web-upsale-4'
];

export const components = {
    "native-language": NativeLanguagePage,
    "language-will-you-translate": LanguageWillYouTranslatePage,
    "try-voery": TryVoeryPage,
    "paywall": PaywallPage,
    "personal-plan-dynamic": PersonalPlanDynamic,
    'upsale-dynamic': UpsaleDynamic,
    'terms-of-use': TermsOfUse,
    'privacy-policy': PrivacyPolicy,
    'web-upsale-4': WebUpsaleFourth,
    'voery-call': VoeryCallPage,
    'change-payment-method': ChangePaymentMethod,


    "analyzing-activity": AnalyzingActivity,

    "analyzing": Analyzing,
    "analyzing-2": AnalyzingSecond,
    "analyzing-3": AnalyzingThird,
    "analyzing-4": AnalyzingFourth,

    "best-app": BestApp,
    "email-2": EmailSecond,

    "name": NamePage,

    "email": EmailPage,
    "email-after-payment": EmailAfterPaymentPage,

    "lts-photo-example": LtsvPhotoExamplePage,
    "face-scan": FaceScanPhoto,
    "face-scan-animation": FaceScanAnimation,
    "face-scan-id": FaceScanId,

    "lts-result": LtsResultPage,
    "personal-plan-2": PersonalPlanSecond,
    "personal-plan-3": PersonalPlanThird,
    "personal-plan-4": PersonalPlanFourth,
    "personal-plan-metabolism": PersonalPlanMetabolism,
    'analyzing-answers': AnalyzingAnswersPage,
    "personal-plan": PersonalPlanPage
}

export const layouts = {
    MainLayout,
    LegalLayout,
    TransitionLayout,
    LtsLayout,
}

export const transitionPages = [
  'transition-1',
  'transition-2',
  'transition-3',
  'transition-4',
  'transition-5',
  'transition-6',
  'transition-7',
  'transition-8'
];
